import React from "react"
import { useKeenSlider } from "keen-slider/react"
import FsLightbox from 'fslightbox-react';

export default (props) => {

  const [lightboxController, setLightboxController] = React.useState({
    toggler: false,
    slide: 1
  })

  function openLightboxOnSlide(number) {
    setLightboxController({
      toggler: !lightboxController.toggler,
      slide: number
    })
  }

  const images = props.images.concat(props.floorplan)

  const [pause, setPause] = React.useState(false)
  const timer = React.useRef()
  const [currentSlide, setCurrentSlide] = React.useState(0)
  const [opacities, setOpacities] = React.useState([])
  const [sliderRef, slider] = useKeenSlider({
    slides: images.length,
    loop: true,
    duration: 3000,
    initial: 0,
    slideChanged(s) {
      setCurrentSlide(s.details().relativeSlide)
    },
    move(s) {
      const new_opacities = s.details().positions.map((slide) => slide.portion)
      setOpacities(new_opacities)
    },
  })

  React.useEffect(() => {
    sliderRef.current.addEventListener("mouseover", () => {
      setPause(true)
    })
    sliderRef.current.addEventListener("mouseout", () => {
      setPause(false)
    })
  }, [sliderRef])

  React.useEffect(() => {
    timer.current = setInterval(() => {
      if (!pause && slider) {
        slider.next()
      }
    }, 6000)
    return () => {
      clearInterval(timer.current)
    }
  }, [pause, slider])

  return (
    <>
      <section className='single-property__slider'>
        <div ref={sliderRef} className="single-property__slider fader">
          {props.images.map((src, idx) => (
            <div
              key={idx}
              className="fader__slide"
              style={{ opacity: opacities[idx] }}
            >
              <img 
                src={src}
                onClick={() => openLightboxOnSlide(idx)}
              />
            </div>
          ))}
        </div>
        {slider && (
          <div className='dots'>
            <div className='dots__inner'>
              {[...Array(slider.details().size).keys()].map((idx) => {
                return (
                  <button
                    key={idx}
                    onClick={() => {
                      slider.moveToSlideRelative(idx)
                    }}
                    className={"dot" + (currentSlide === idx ? " active" : "")}
                  />
                )
              })}
            </div>
          </div>
        )}
      </section>
      <FsLightbox
        toggler={lightboxController.toggler}
        sources={images.map((src, idx) => (
          <img 
            key={idx}
            src={src}
          />
        ))}
      />
    </>
  )
}
